var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.tag.meta.affix)?_c('img',{staticStyle:{"vertical-align":"middle"},attrs:{"src":_vm.closeImage},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.closeSelectedTag(_vm.tag)},"mouseenter":_vm.handleMouseEnter,"mouseleave":_vm.handleMouseLeave}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }